export default "__VITE_ASSET__adf176c4__"